import React from 'react';
import './appMain.css';
import '../components/userProfileLogo.css';
import {FormattedMessage} from 'react-intl';
import {withRouter} from 'react-router'
import Menu from 'material-ui-icons/Menu'
import Clear from 'material-ui-icons/Clear'

class AppHeaderWithMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentRoute: "",
        }
    }

    componentWillReceiveProps = (newProps) => {
        let currentRoute;
        if (newProps.location.pathname === "/") {
            currentRoute = <FormattedMessage id="sidemenu.myEventsText"/>;
        } else if (newProps.location.pathname === "/playlist") {
            currentRoute= <FormattedMessage id = "sidemenu.recommendationsText"/>;
        } else if (newProps.location.pathname === "/events/currentEventDetails")  {
            currentRoute = <FormattedMessage id = "eventPageHeader.details"/>;
        } else if (newProps.location.pathname === "/templates") {
            currentRoute = <FormattedMessage id = "sidemenu.templatesText"/>;
        } else if (newProps.location.pathname === "/userInfo") {
            currentRoute = <FormattedMessage id = "sidemenu.userInfoText"/>;
        } else if (newProps.location.pathname === "/scanner") {
            currentRoute = <FormattedMessage id = "sidemenu.scannerText"/>;
        }
        this.setState({
            currentRoute: currentRoute,
        })
    };

    render(){
        return (
            <div className="an-header">
                { this.props.visible ?
                    <div className="header-left">
                        {this.props.menuOpen ?
                            <Clear className="menu-icon" onClick={this.props.toggleMenu}/>
                            : <Menu className="menu-icon" onClick={this.props.toggleMenu}/>
                        }
                        <span className="pageName">{this.state.currentRoute}</span>
                    </div>
                    : null
                }
            </div>
        );
    }
}

export default withRouter(AppHeaderWithMenu);



// WEBPACK FOOTER //
// ./src/containers/appHeaderWithMenu.js